<template>
    <div class="users">
        <div class="user-data">
            <el-table :data="users">
                <el-table-column :label="$t('cheng_yuan_xin_xi')" align="center">
                    <template slot-scope="scope">
                        <div class="user-info">
                            <div class="user-info-img"><img :src="scope.row.avatar"/></div>
                            <div class="user-info-detail">
                                <p>{{scope.row.name}}</p>
                                <p>{{scope.row.phone}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('zhu_ce_shi_jian')" align="center" prop="createdAt">
                    <template slot-scope="scope">
                    <span>
                        {{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                    <template slot-scope="scope">
                        <span @click="handleDelete(scope.row, scope.$index)" class="user-delete">{{$t('qu_xiao_bang_ding')}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>

    </div>

</template>

<script>
    import {groupUserUnion, groupUserList, groupUserDelete} from  '@/api/delivery/organization/group'
    export default {
        name: '',
        components: {},
        mounted: function () {
        },
        data: function () {
            return {
                users: [],
                editUserVisible: false,
                user: {
                    name: "",
                    avatar: "",
                    phone: "",
                    password: "",

                },
                pagination: {
                    name: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                    departmentUuid: ''
                },
            }
        },
        methods: {
            initDepartment(departmentUUID, name = '') {
                this.pagination.name = name
                this.pagination.departmentUuid = departmentUUID
                this.pagination.start = 0
                groupUserUnion(this.pagination).then(res => {
                    this.users = res.data.list || []
                    this.pagination.total = parseInt(res.data.total)
                })
            },
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                groupUserList(this.pagination).then(res => {
                    this.users = res.data
                })
            },
            handleDelete(row, index) {
                this.$confirm('此操作将移除成员与部门关系, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    groupUserDelete({uuid: row.uuid, departmentUuid: this.pagination.departmentUuid}).then(() => {
                        this.initDepartment(this.pagination.departmentUuid)
                    })
                }).catch(() => {

                })
            },
        },
    }
</script>

<style lang="scss">
    .users {
        height: 100%;
        display: flex;
        flex-direction: column;
        .user-data {
            flex: 1;

            .user-info {
                display: flex;
                justify-content: center;
                align-items: center;
                .user-info-img {
                    img {
                        max-width: 2rem;
                    }
                }
                .user-info-detail {
                    margin-left: $padding;
                    text-align: left;
                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .el-table {
                thead {
                    tr {
                        th {
                            border-bottom: 1px solid $border_sec_color;
                            background-color: $bg_sev_color;
                        }
                    }
                }

            }
            .el-table--group::after, .el-table--border::after, .el-table::before {
                background-color: transparent;
            }
            .el-table__row:hover {
                background-color: $bg_sec_color;
            }

            .user-edit, .user-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .user-edit {
                color: $btn_color;
            }
            .user-delete {
                color: $btn_sec_color;
            }
        }

        .pagination {
            margin: $padding;
            text-align: right;
        }
    }

</style>
